/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Caption_HintInputs */

const en_reading_class_caption_hint = /** @type {(inputs: Reading_Class_Caption_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text under images and tables`)
};

const es_reading_class_caption_hint = /** @type {(inputs: Reading_Class_Caption_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto bajo imágenes y tablas`)
};

/**
* | output |
* | --- |
* | "Text under images and tables" |
*
* @param {Reading_Class_Caption_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_caption_hint = /** @type {((inputs?: Reading_Class_Caption_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Caption_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_caption_hint(inputs)
	return en_reading_class_caption_hint(inputs)
});